<template>
    <div class="estimate-advance-table">
        <el-table class="table" :data="data" v-loading="isLoading">
            <el-table-column width="180">
                <template slot-scope="scope">
                    <template>
                        <el-input v-if="scope.row.custom" v-model="scope.row.iteM_NAM"></el-input>
                        <span v-else>{{ scope.row.iteM_NAM }}</span>
                    </template>
                </template>
            </el-table-column>
            <el-table-column label="分類" align="right">
                <template slot-scope="scope">
                    <el-select v-model="scope.row.grP_NAM" :disabled="!scope.row.custom">
                        <el-option v-for="item in incomeStatementList" :label="`${item.id}. ${item.value}`" :value="item.id" :key="item.id" :disabled="!(item.id === 5 || item.id === 6)"></el-option>
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column label="實際支出" align="right">
                <template slot-scope="scope">
                    <template v-if="!scope.row.custom">
                        <Money :v="scope.row.actuallyAmount" round />
                    </template>
                </template>
            </el-table-column>
            <el-table-column align="right">
                <!-- eslint-disable-next-line vue/no-unused-vars -->
                <template slot="header" slot-scope="scope">
                    <div class="table-header">
                        <div class="label">請款待付款</div>
                        <div class="total">
                            <span>總額：</span>
                            <Money :v="estimatedAmount" round />
                        </div>
                        <div class="remain">
                            <span>未分配差額：</span>
                            <Money :v="nonDistributedNonProjectAmt" round />
                        </div>
                    </div>
                </template>
                <template slot-scope="scope">
                    <template>
                        <MoneyInput v-if="!scope.row.custom" v-model="scope.row.nonProjectAmount" round />
                    </template>
                </template>
            </el-table-column>
            <el-table-column label="預估請款支出金額" align="right">
                <template slot-scope="scope">
                    <template>
                        <MoneyInput v-model="scope.row.futureAmt" round />
                    </template>
                </template>
            </el-table-column>
            <el-table-column label="預估年度總支出" align="right">
                <template slot-scope="scope">
                    <Money :v="getTotalAmt(scope.row)" round />
                </template>
            </el-table-column>
            <el-table-column label="佔總支出" align="right">
                <template slot-scope="scope">
                    {{ getPercentage(getTotalAmt(scope.row), totalAmt) }}
                    %
                </template>
            </el-table-column>
            <el-table-column width="100" align="center">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.custom" @click="$emit('delete', scope.$index)">
                        刪除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-table class="table-bottom" :data="[{}]" :show-header="false">
            <el-table-column width="180">
                <!-- eslint-disable-next-line vue/no-unused-vars -->
                <template slot-scope="scope">
                    <div class="summary-block">
                        <el-button @click="$emit('add')">新增</el-button>
                        <div>總計</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="實際支出" align="right">
                <!-- eslint-disable-next-line vue/no-unused-vars -->
                <template slot-scope="scope">
                    <template>
                        <Money :v="actuallyAmount" round />
                    </template>
                </template>
            </el-table-column>
            <el-table-column></el-table-column>
            <el-table-column align="right">
                <!-- eslint-disable-next-line vue/no-unused-vars -->
                <template slot-scope="scope">
                    <template>
                        <Money :v="futureAmount" round />
                    </template>
                </template>
            </el-table-column>
            <el-table-column align="right">
                <!-- eslint-disable-next-line vue/no-unused-vars -->
                <template slot-scope="scope">
                    <Money :v="totalAmt" round />
                </template>
            </el-table-column>
            <el-table-column align="right">100 %</el-table-column>
            <el-table-column width="100"></el-table-column>
        </el-table>
    </div>
</template>

<script>
import { accountingSettingGroup } from '@/assets/commonData/options';
import AdvanceMixins from './AdvanceMixins';

export default {
    mixins: [AdvanceMixins],

    computed: {
        incomeStatementList() {
            return accountingSettingGroup.filter((o) => o.id > 3 && o.id < 9);
        },
    },
};
</script>

<style lang="scss">
.estimate-advance-table {
    @media print {
        display: none;
    }
    .summary-block {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
}
</style>
